import { format } from "date-fns";

export const formatDateString = (dateString: string): string => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    }).format(date);
  };


  export const formatDayTimeString = (dateString: string): string => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-CA", {
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23",
    }).format(date);
  };
  


  export const formatPrice = (price: number) =>
    new Intl.NumberFormat().format(price) + "₮";

  export const getDayCount = (start_date:string, end_date:string) => {
    return (Math.abs(new Date(end_date).getTime() - new Date(start_date).getTime()) /
      (1000 * 60 * 60 * 24)) ;
  }

  export const formatDate = (dateStr: string) => format(new Date(dateStr), "MM/dd");

  export const formatDateWithYear = (dateStr: string) => format(new Date(dateStr), "yyyy/MM/dd");